import { render, staticRenderFns } from "./PatientVoiceChat.vue?vue&type=template&id=931971aa&scoped=true"
import script from "./PatientVoiceChat.vue?vue&type=script&lang=js"
export * from "./PatientVoiceChat.vue?vue&type=script&lang=js"
import style0 from "./PatientVoiceChat.vue?vue&type=style&index=0&id=931971aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "931971aa",
  null
  
)

export default component.exports